import { io } from 'socket.io-client';
import config from '$config';

export default (accessToken, bookingId) => io(config.sockets.url, { query: { accessToken, bookingId } });
